import { OdataManager } from '@/api/odata/odata-manager';
import { AdditionalAgreement } from '@/api/model/interfaces';

export default class AdditionalAgreementOdata extends OdataManager<AdditionalAgreement> {}
